module.exports = __webpack_public_path__ + "img/card-with-line.c3dd6156.svg";